import { log } from '@/composables/useLog'
import { BASE_URL } from '@/composables/url_config'

export async function getDisplaySettings(token) {
  try {
    const response = await fetch(`${BASE_URL}/home/get_display_settings_api`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
    return await response.json()
  } catch (error) {
    log('getDisplaySettings error: ' + error)
    return { error: true, message: error.message }
  }
}

export async function updateDisplaySettings(token, settings) {
  try {
    const response = await fetch(`${BASE_URL}/home/update_display_settings_api`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ settings })
    })
    return await response.json()
  } catch (error) {
    log('updateDisplaySettings error: ' + error)
    return { error: true, message: error.message }
  }
}

export async function rebuildClientStatistics(token, { clientId, rebuildAll } = {}) {
  try {
    const body = {}
    if (rebuildAll) body.rebuild_all = true
    if (clientId) body.client_id = clientId

    const response = await fetch(`${BASE_URL}/home/rebuild_client_statistics_api`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(body)
    })
    return await response.json()
  } catch (error) {
    log('rebuildClientStatistics error: ' + error)
    return { error: true, message: error.message }
  }
}
